module.exports = __webpack_public_path__ + "static/media/kinetic.c86ec8e7.png";